export const initialExpression = {
  logic: 'and',
  filters: [],
};

export const initialFilterName = 'New Filter';

export const initialFilter = {
  name: initialFilterName,
  expression: initialExpression,
};
